/* Aimer Atacado — Central de Mídia.
   Seleciona coleção (fetch ?view=midia-json) ou busca peça por nome/SKU
   (predictive search nativo + /products/{handle}.js), monta grade com
   checkbox e baixa em lote em .zip.
   Download individual reaproveita o listener global de aimer-download-assets:
   basta renderizar um botão [data-aimer-baixar] — nenhum JS extra precisa
   ser escrito para isso funcionar.

   v2 (out/2026) — "Seus pedidos": lista os pedidos da revendedora logada
   (JSON data-cm-pedidos-json impresso pela seção a partir de customer.orders),
   abre um pedido com todas as peças e baixa fotos e vídeos em .zip.
   Link direto: ?pedido=1064 (usado no e-mail de confirmação de pedido).
   O .zip é montado no navegador, sem biblioteca: modo "store" (sem
   compressão — jpg/png/mp4 já vêm comprimidos), cada arquivo vira um Blob e
   o .zip final é uma concatenação de Blobs, sem copiar os bytes de novo.
   No celular os arquivos são divididos em partes de até ~300 MB (vídeos de um
   pedido grande passam de 800 MB), no computador até ~1 GB. */
(function () {
  var root = document.querySelector('[data-cm]');
  if (!root) return;

  var els = {
    colecoes: root.querySelector('[data-cm-colecoes]'),
    voltar: root.querySelector('[data-cm-voltar]'),
    grid: root.querySelector('[data-cm-grid]'),
    gridTitulo: root.querySelector('[data-cm-grid-titulo]'),
    catalogo: root.querySelector('[data-cm-catalogo]'),
    vazio: root.querySelector('[data-cm-vazio]'),
    carregarMais: root.querySelector('[data-cm-carregar-mais]'),
    busca: root.querySelector('[data-cm-busca]'),
    barra: root.querySelector('[data-cm-barra]'),
    barraTexto: root.querySelector('[data-cm-barra-texto]'),
    selecionarTodas: root.querySelector('[data-cm-selecionar-todas]'),
    limpar: root.querySelector('[data-cm-limpar]'),
    baixarZip: root.querySelector('[data-cm-baixar-zip]'),
    pedidos: root.querySelector('[data-cm-pedidos]'),
    pedidoPainel: root.querySelector('[data-cm-pedido-painel]'),
  };

  var THUMB_W = parseInt(root.getAttribute('data-thumb-largura'), 10) || 400;
  var FULL_W = parseInt(root.getAttribute('data-download-largura'), 10) || 2048;
  var TXT = {
    carregarMais: root.getAttribute('data-texto-carregar-mais') || 'Carregar mais peças',
    baixarRapido: root.getAttribute('data-texto-baixar-rapido') || 'Baixar',
    semFoto: 'Sem foto cadastrada',
    voltar: root.getAttribute('data-texto-voltar') || '← Ver outras coleções',
    voltarPedido: '← Voltar',
    pedidosTitulo: root.getAttribute('data-pedidos-titulo') || 'Seus pedidos',
    pedidosSub: root.getAttribute('data-pedidos-subtitulo') || '',
  };
  var ICONE_BAIXAR = '<span class="aimer-dl__icone" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg></span>';

  var selected = new Map(); // id -> { id, title, sku, midias }
  var currentHandle = null;
  var currentPage = 1;
  var currentPages = 1;
  var searchToken = 0;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function esperar(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function rotaRaiz() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* --- Grade de peças --- */

  function dlBtnHtml(midia) {
    var isVideo = midia.tipo === 'video';
    return (
      '<button type="button" class="aimer-dl aimer-dl--mini" data-aimer-baixar' +
      (isVideo ? ' data-tipo="video"' : '') +
      ' data-src="' + esc(midia.full) + '" data-filename="' + esc(midia.filename) + '">' +
      '<span class="aimer-dl__icone" aria-hidden="true"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg></span>' +
      '<span class="aimer-dl__label">' + esc(isVideo ? 'Baixar vídeo' : TXT.baixarRapido) + '</span></button>'
    );
  }

  function midiaHtml(midia) {
    var thumb = midia.tipo === 'video'
      ? '<span class="cm-midia__thumb cm-midia__thumb--video">' +
          '<img src="' + esc(midia.thumb) + '" alt="" loading="lazy">' +
          '<span class="cm-midia__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' +
        '</span>'
      : '<span class="cm-midia__thumb"><img src="' + esc(midia.thumb) + '" alt="" loading="lazy"></span>';

    return '<figure class="cm-midia">' + thumb + dlBtnHtml(midia) + '</figure>';
  }

  function cardHtml(product) {
    var midias = product.midias || [];
    var isChecked = selected.has(String(product.id));
    var midiasHtml = midias.length
      ? midias.map(midiaHtml).join('')
      : '<p class="cm-card__semfoto">' + TXT.semFoto + '</p>';

    return (
      '<div class="cm-card' + (isChecked ? ' is-selecionado' : '') + '" data-cm-card data-id="' + esc(product.id) + '">' +
        '<div class="cm-card__head">' +
          '<label class="cm-card__toggle">' +
            '<input type="checkbox" class="cm-card__check" data-cm-check' + (isChecked ? ' checked' : '') + '>' +
            '<span class="cm-card__marca" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg></span>' +
          '</label>' +
          '<div class="cm-card__info">' +
            '<p class="cm-card__nome">' + esc(product.title) + '</p>' +
            (product.sku ? '<p class="cm-card__sku">SKU ' + esc(product.sku) + '</p>' : '') +
          '</div>' +
          '<a href="' + esc(product.url) + '" class="cm-card__link">Ver peça</a>' +
        '</div>' +
        '<div class="cm-card__midias">' + midiasHtml + '</div>' +
      '</div>'
    );
  }

  function renderProducts(products, append) {
    if (!append) els.grid.innerHTML = '';
    var html = products.map(cardHtml).join('');
    els.grid.insertAdjacentHTML('beforeend', html);
    els.vazio.hidden = els.grid.children.length > 0;
  }

  els.grid.addEventListener('change', function (e) {
    var check = e.target.closest('[data-cm-check]');
    if (!check) return;
    var card = check.closest('[data-cm-card]');
    var id = card.getAttribute('data-id');
    if (check.checked) {
      var product = productById[id];
      if (product) selected.set(id, product);
      card.classList.add('is-selecionado');
    } else {
      selected.delete(id);
      card.classList.remove('is-selecionado');
    }
    updateBar();
  });

  var productById = {};
  function indexProducts(products) {
    products.forEach(function (p) { productById[String(p.id)] = p; });
  }

  /* --- Coleções --- */

  function renderCatalogo(pdfUrl) {
    if (!pdfUrl) {
      els.catalogo.hidden = true;
      els.catalogo.innerHTML = '';
      return;
    }
    els.catalogo.innerHTML =
      '<span class="aimer-cm__catalogo-label">Catálogo da coleção</span>' +
      '<a href="' + esc(pdfUrl) + '" download class="aimer-dl aimer-dl--contorno">' +
        '<span class="aimer-dl__icone" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg></span>' +
        '<span class="aimer-dl__label">Baixar PDF</span>' +
      '</a>';
    els.catalogo.hidden = false;
  }

  function loadCollection(handle, url, page) {
    page = page || 1;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + sep + 'view=midia-json&page=' + page;
    els.carregarMais.disabled = true;
    if (page === 1) fecharPedido();
    mostrarListaPedidos(false);

    return fetch(fetchUrl)
      .then(function (r) { return r.text().then(function (text) { return { ok: r.ok, status: r.status, text: text }; }); })
      .then(function (res) {
        if (window.console) console.log('[aimer-central-midia] resposta bruta de ' + fetchUrl + ':', res.text.slice(0, 800));

        var data;
        try {
          data = JSON.parse(res.text);
        } catch (e) {
          throw new Error('resposta não é JSON (status ' + res.status + '): ' + res.text.slice(0, 200));
        }
        if (!data || typeof data.collection !== 'string' || !Array.isArray(data.products)) {
          throw new Error('formato inesperado: ' + JSON.stringify(data).slice(0, 200));
        }

        currentHandle = handle;
        currentPage = data.page || 1;
        currentPages = data.pages || 1;
        indexProducts(data.products);
        renderProducts(data.products, page > 1);
        els.gridTitulo.textContent = data.collection;
        renderCatalogo(data.catalogo_pdf);
        els.voltar.hidden = false;
        els.colecoes.hidden = true;
        els.grid.hidden = false;
        els.gridTitulo.hidden = false;
        els.carregarMais.hidden = currentPage >= currentPages;
        els.carregarMais.disabled = false;
      })
      .catch(function (err) {
        els.carregarMais.disabled = false;
        els.voltar.hidden = false;
        els.colecoes.hidden = true;
        els.grid.hidden = false;
        els.grid.innerHTML = '';
        els.gridTitulo.hidden = true;
        renderCatalogo(null);
        els.carregarMais.hidden = true;
        els.vazio.hidden = false;
        els.vazio.textContent = 'Não foi possível carregar esta coleção. ' + (err && err.message ? err.message : '');
        if (window.console) console.error('[aimer-central-midia] loadCollection falhou:', err);
      });
  }

  root.querySelectorAll('[data-cm-colecao]').forEach(function (card) {
    card.addEventListener('click', function () {
      var handle = card.getAttribute('data-handle');
      var url = card.getAttribute('data-url');
      els.busca.value = '';
      loadCollection(handle, url, 1);
    });
  });

  els.carregarMais.addEventListener('click', function () {
    if (!currentHandle) return;
    var url = root.querySelector('[data-cm-colecao][data-handle="' + currentHandle + '"]');
    var baseUrl = url ? url.getAttribute('data-url') : '/collections/' + currentHandle;
    loadCollection(currentHandle, baseUrl, currentPage + 1);
  });

  els.voltar.addEventListener('click', function (e) {
    e.preventDefault();
    fecharPedido();
    currentHandle = null;
    els.busca.value = '';
    els.colecoes.hidden = false;
    els.grid.hidden = true;
    els.gridTitulo.hidden = true;
    renderCatalogo(null);
    els.voltar.hidden = true;
    els.carregarMais.hidden = true;
    els.vazio.hidden = true;
    mostrarListaPedidos(true);
  });

  /* --- Busca (nome ou SKU, catálogo inteiro) --- */

  function runSearch(query) {
    var token = ++searchToken;
    if (!query || query.trim().length < 2) {
      if (pedidoAberto) return; // 1 letra digitada com um pedido aberto: o pedido continua na tela
      if (currentHandle) {
        els.grid.hidden = false;
        els.gridTitulo.hidden = false;
        els.voltar.hidden = false;
        els.colecoes.hidden = true;
      } else {
        els.colecoes.hidden = false;
        els.grid.hidden = true;
        els.gridTitulo.hidden = true;
        els.voltar.hidden = true;
        mostrarListaPedidos(true);
      }
      els.carregarMais.hidden = true;
      els.vazio.hidden = true;
      return;
    }

    renderCatalogo(null); // busca é cross-coleção, catálogo em PDF não se aplica
    fecharPedido();
    mostrarListaPedidos(false);

    var base = rotaRaiz();
    var url = base + 'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,variants.sku,product_type,vendor';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('suggest http ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (token !== searchToken) return; // resposta antiga, ignora
        var hits = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!hits.length) {
          els.colecoes.hidden = true;
          els.gridTitulo.hidden = true;
          els.voltar.hidden = true;
          els.grid.hidden = false;
          els.grid.innerHTML = '';
          els.carregarMais.hidden = true;
          els.vazio.hidden = false;
          els.vazio.textContent = 'Nenhuma peça encontrada.';
          return;
        }
        return Promise.all(hits.map(function (hit) {
          return fetch(base + 'products/' + hit.handle + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('product http ' + r.status); return r.json(); })
            .catch(function () { return null; });
        })).then(function (fullProducts) {
          if (token !== searchToken) return;
          var products = fullProducts.filter(Boolean).map(normalizeAjaxProduct);
          indexProducts(products);
          els.colecoes.hidden = true;
          els.gridTitulo.hidden = true;
          els.voltar.hidden = false;
          els.grid.hidden = false;
          if (!products.length) {
            els.grid.innerHTML = '';
            els.carregarMais.hidden = true;
            els.vazio.hidden = false;
            els.vazio.textContent = 'Nenhuma peça encontrada.';
            return;
          }
          renderProducts(products, false);
          els.carregarMais.hidden = true;
        });
      })
      .catch(function (err) {
        if (token !== searchToken) return;
        els.colecoes.hidden = true;
        els.gridTitulo.hidden = true;
        els.voltar.hidden = true;
        els.grid.hidden = false;
        els.grid.innerHTML = '';
        els.carregarMais.hidden = true;
        els.vazio.hidden = false;
        els.vazio.textContent = 'Não foi possível buscar agora. Tente de novo em instantes.';
        if (window.console) console.error('[aimer-central-midia] busca falhou:', err);
      });
  }

  function absUrl(src) {
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function melhorMp4(sources) {
    var best = null;
    (sources || []).forEach(function (s) {
      if (s.format === 'mp4' && (!best || s.height > best.height)) best = s;
    });
    return best;
  }

  function normalizeAjaxProduct(p) {
    var sku = (p.variants && p.variants[0] && p.variants[0].sku) || '';
    var slug = (p.handle || p.title || 'aimer').toString();
    var i = 0;

    var photos = (p.images || []).map(function (src) {
      i += 1;
      var base = absUrl(src).split('?')[0];
      var fn = (sku ? sku + '-' : '') + slug + '-' + i + '.jpg';
      return { tipo: 'foto', thumb: base + '?width=' + THUMB_W, full: base + '?width=' + FULL_W, filename: fn };
    });

    var videos = (p.media || [])
      .filter(function (m) { return m.media_type === 'video' && m.sources && m.sources.length; })
      .map(function (m) {
        var best = melhorMp4(m.sources);
        if (!best) return null;
        i += 1;
        var poster = m.preview_image && m.preview_image.src ? absUrl(m.preview_image.src) + '?width=' + THUMB_W : '';
        return { tipo: 'video', thumb: poster, full: absUrl(best.url), filename: slug + '-' + i + '.mp4' };
      })
      .filter(Boolean);

    return { id: p.id, title: p.title, sku: sku, handle: p.handle, url: p.url, midias: photos.concat(videos) };
  }

  els.busca.addEventListener('input', debounce(function () {
    runSearch(els.busca.value);
  }, 320));

  /* --- Barra fixa de seleção --- */

  function updateBar() {
    var n = selected.size;
    els.barra.hidden = n === 0;
    if (n > 0) {
      els.barraTexto.textContent = n === 1 ? '1 peça selecionada' : n + ' peças selecionadas';
    }
  }

  els.selecionarTodas.addEventListener('click', function () {
    root.querySelectorAll('[data-cm-card]').forEach(function (card) {
      var id = card.getAttribute('data-id');
      var product = productById[id];
      if (!product) return;
      selected.set(id, product);
      card.classList.add('is-selecionado');
      var check = card.querySelector('[data-cm-check]');
      if (check) check.checked = true;
    });
    updateBar();
  });

  els.limpar.addEventListener('click', function () {
    selected.clear();
    root.querySelectorAll('[data-cm-card].is-selecionado').forEach(function (card) {
      card.classList.remove('is-selecionado');
      var check = card.querySelector('[data-cm-check]');
      if (check) check.checked = false;
    });
    updateBar();
  });

  /* --- ZIP montado no navegador (modo store) --- */

  var CRC_TABELA = null;
  function crc32(bytes) {
    if (!CRC_TABELA) {
      CRC_TABELA = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        CRC_TABELA[n] = c >>> 0;
      }
    }
    var crc = 0xffffffff;
    for (var i = 0; i < bytes.length; i++) crc = CRC_TABELA[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }

  /* arquivos: [{ nome: 'pasta/arquivo.jpg', blob, crc, tamanho }] -> Blob .zip.
     Cabeçalho local + bytes de cada arquivo, depois o diretório central e o
     registro de fim. Nomes em UTF-8 (bit 11). Sem Zip64: as partes ficam
     bem abaixo de 4 GB. */
  function montarZip(arquivos) {
    var enc = new TextEncoder();
    var agora = new Date();
    var hora = (agora.getHours() << 11) | (agora.getMinutes() << 5) | (agora.getSeconds() >> 1);
    var dia = ((agora.getFullYear() - 1980) << 9) | ((agora.getMonth() + 1) << 5) | agora.getDate();
    var corpo = [];
    var central = [];
    var tamanhoCentral = 0;
    var offset = 0;

    arquivos.forEach(function (a) {
      var nome = enc.encode(a.nome);

      var local = new DataView(new ArrayBuffer(30));
      local.setUint32(0, 0x04034b50, true);
      local.setUint16(4, 20, true);
      local.setUint16(6, 0x0800, true);
      local.setUint16(8, 0, true);
      local.setUint16(10, hora, true);
      local.setUint16(12, dia, true);
      local.setUint32(14, a.crc, true);
      local.setUint32(18, a.tamanho, true);
      local.setUint32(22, a.tamanho, true);
      local.setUint16(26, nome.length, true);
      local.setUint16(28, 0, true);
      corpo.push(local, nome, a.blob);

      var cab = new DataView(new ArrayBuffer(46));
      cab.setUint32(0, 0x02014b50, true);
      cab.setUint16(4, 20, true);
      cab.setUint16(6, 20, true);
      cab.setUint16(8, 0x0800, true);
      cab.setUint16(10, 0, true);
      cab.setUint16(12, hora, true);
      cab.setUint16(14, dia, true);
      cab.setUint32(16, a.crc, true);
      cab.setUint32(20, a.tamanho, true);
      cab.setUint32(24, a.tamanho, true);
      cab.setUint16(28, nome.length, true);
      cab.setUint32(42, offset, true);
      central.push(cab, nome);

      tamanhoCentral += 46 + nome.length;
      offset += 30 + nome.length + a.tamanho;
    });

    var fim = new DataView(new ArrayBuffer(22));
    fim.setUint32(0, 0x06054b50, true);
    fim.setUint16(8, arquivos.length, true);
    fim.setUint16(10, arquivos.length, true);
    fim.setUint32(12, tamanhoCentral, true);
    fim.setUint32(16, offset, true);
    return new Blob(corpo.concat(central, [fim]), { type: 'application/zip' });
  }

  /* A extensão segue o que o CDN entregou: foto cadastrada em .webp chega como
     JPG quando pedida sem "Accept: image/webp" (caso do fetch). */
  var EXTENSOES = { 'image/jpeg': '.jpg', 'image/png': '.png', 'image/webp': '.webp', 'image/gif': '.gif', 'video/mp4': '.mp4' };
  function nomeComExtensao(nome, tipo) {
    var ext = EXTENSOES[tipo];
    return ext ? nome.replace(/\.[A-Za-z0-9]{2,4}$/, '') + ext : nome;
  }

  /* Baixa jobs [{ url, nome }] (4 por vez, 2 novas tentativas por arquivo).
     Resolve { arquivos, falhas } na ordem dos jobs; rejeita se cancelado. */
  var SIMULTANEOS = 4;
  function baixarArquivos(jobs, opcoes) {
    opcoes = opcoes || {};
    var sinal = opcoes.sinal;
    var arquivos = new Array(jobs.length);
    var falhas = [];
    var feitos = 0;
    var bytes = 0;
    var proximo = 0;

    function baixarUm(job, i, tentativa) {
      return fetch(job.url, { mode: 'cors', signal: sinal })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          var tipo = (r.headers.get('content-type') || '').split(';')[0].trim().toLowerCase();
          return r.arrayBuffer().then(function (buf) { return { buf: buf, tipo: tipo }; });
        })
        .then(function (res) {
          var buf = res.buf;
          arquivos[i] = { nome: nomeComExtensao(job.nome, res.tipo), tamanho: buf.byteLength, crc: crc32(new Uint8Array(buf)), blob: new Blob([buf]) };
          job.tamanho = buf.byteLength; // tamanho real substitui a estimativa (o total do progresso se acerta sozinho)
          bytes += buf.byteLength;
        }, function (err) {
          if (sinal && sinal.aborted) throw err;
          if (tentativa < 2) {
            return esperar(800 * (tentativa + 1)).then(function () { return baixarUm(job, i, tentativa + 1); });
          }
          falhas.push(job);
        });
    }

    return new Promise(function (resolve, reject) {
      var ativos = 0;
      var encerrado = false;
      function seguir() {
        if (encerrado) return;
        if (sinal && sinal.aborted) { encerrado = true; reject(new Error('cancelado')); return; }
        if (proximo >= jobs.length && ativos === 0) {
          encerrado = true;
          resolve({ arquivos: arquivos.filter(Boolean), falhas: falhas });
          return;
        }
        while (ativos < SIMULTANEOS && proximo < jobs.length) {
          (function (i) {
            ativos += 1;
            baixarUm(jobs[i], i, 0).then(function () {
              ativos -= 1;
              feitos += 1;
              if (opcoes.aoProgredir) opcoes.aoProgredir(feitos, bytes);
              seguir();
            }, function (err) {
              ativos -= 1;
              if (!encerrado) { encerrado = true; reject(err); }
            });
          })(proximo++);
        }
      }
      seguir();
    });
  }

  /* Entrega o Blob como download. A URL fica viva alguns minutos (o celular
     pode demorar a confirmar o "Baixar?") e é revogada antes do próximo .zip
     para não acumular centenas de MB na memória. */
  var urlsEntregues = [];
  function revogar(url) {
    var i = urlsEntregues.indexOf(url);
    if (i === -1) return;
    urlsEntregues.splice(i, 1);
    URL.revokeObjectURL(url);
  }
  function revogarEntregues() {
    urlsEntregues.slice().forEach(revogar);
  }
  function salvarBlob(blob, nome) {
    var url = URL.createObjectURL(blob);
    urlsEntregues.push(url);
    var a = document.createElement('a');
    a.href = url;
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { revogar(url); }, 5 * 60 * 1000);
  }

  /* --- Download em lote das peças marcadas (barra fixa) --- */

  function runPool(items, worker, concurrency) {
    var i = 0;
    var active = 0;
    return new Promise(function (resolve) {
      function next() {
        if (i >= items.length && active === 0) { resolve(); return; }
        while (active < concurrency && i < items.length) {
          var item = items[i++];
          active++;
          worker(item).finally(function () {
            active--;
            next();
          });
        }
      }
      next();
    });
  }

  els.baixarZip.addEventListener('click', function () {
    if (selected.size === 0 || els.baixarZip.classList.contains('is-loading')) return;

    var jobs = [];
    var usedNames = {};
    selected.forEach(function (product) {
      (product.midias || []).filter(function (m) { return m.tipo === 'foto'; }).forEach(function (photo) {
        var name = photo.filename;
        if (usedNames[name]) {
          name = product.id + '-' + name;
        }
        usedNames[name] = true;
        jobs.push({ url: photo.full, nome: name });
      });
    });

    if (jobs.length === 0) {
      barraProgresso('Nenhuma foto disponível nas peças selecionadas.');
      setTimeout(updateBar, 2600);
      return;
    }

    els.baixarZip.classList.add('is-loading');
    revogarEntregues();
    barraProgresso('Preparando 0 de ' + jobs.length + '...');

    baixarArquivos(jobs, {
      aoProgredir: function (feitos) { barraProgresso('Preparando ' + feitos + ' de ' + jobs.length + '...'); },
    }).then(function (res) {
      if (!res.arquivos.length) throw new Error('nenhuma foto baixou');
      barraProgresso('Compactando arquivo...');
      return esperar(30).then(function () {
        salvarBlob(montarZip(res.arquivos), 'aimer-central-de-midia-' + selected.size + '-pecas.zip');
        var falhas = res.falhas.length;
        barraProgresso(falhas > 0
          ? 'Baixado! ' + res.arquivos.length + ' de ' + jobs.length + ' fotos (' + falhas + ' falharam).'
          : 'Baixado! ' + jobs.length + ' fotos.');
        setTimeout(updateBar, 2600);
      });
    }).catch(function (err) {
      barraProgresso('Não foi possível gerar o ZIP. Tente novamente.');
      setTimeout(updateBar, 2600);
      if (window.console) console.error('[aimer-central-midia] zip da seleção falhou:', err);
    }).then(function () {
      els.baixarZip.classList.remove('is-loading');
    });
  });

  function barraProgresso(msg) {
    els.barraTexto.textContent = msg;
  }

  /* --- Seus pedidos --- */

  var ESTIMATIVA = { foto: 450 * 1000, video: 14 * 1000 * 1000 };
  var pedidos = lerPedidos();
  var pedidoAberto = null;
  var pedidoToken = 0;
  var tarefa = null; // download de pedido em andamento: { botao, controle }
  var mostrarTodosPedidos = false;
  var avisoPedidos = '';

  function lerPedidos() {
    var tag = root.querySelector('[data-cm-pedidos-json]');
    if (!tag) return [];
    try {
      var lista = JSON.parse(tag.textContent);
      return Array.isArray(lista) ? lista.filter(function (p) { return p && p.numero != null; }) : [];
    } catch (e) {
      if (window.console) console.error('[aimer-central-midia] JSON de pedidos inválido:', e);
      return [];
    }
  }

  function plural(n, um, varios) {
    return n + ' ' + (n === 1 ? um : varios);
  }

  function doisDigitos(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Nome seguro para pasta/arquivo em qualquer sistema (Windows inclusive). */
  function limparNome(s) {
    var t = String(s || '');
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    t = t.replace(/[^A-Za-z0-9 ._()+&-]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 80);
    return t.replace(/[ .]+$/, '') || 'Aimer';
  }

  function extensao(url, padrao) {
    var m = /\.(jpe?g|png|webp|gif)$/i.exec(url.split('?')[0]);
    return m ? '.' + m[1].toLowerCase() : padrao;
  }

  function tamanhoDe(job) {
    return job.tamanho || ESTIMATIVA[job.tipo] || 0;
  }

  function somaTamanhos(jobs) {
    return jobs.reduce(function (s, j) { return s + tamanhoDe(j); }, 0);
  }

  function fmtTamanho(bytes) {
    if (bytes >= 1e9) return (bytes / 1e9).toFixed(1).replace('.', ',') + ' GB';
    if (bytes >= 1e6) return Math.max(1, Math.round(bytes / 1e6)) + ' MB';
    return Math.max(1, Math.round(bytes / 1e3)) + ' KB';
  }

  function telaDeToque() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  function limiteParte() {
    return (telaDeToque() ? 300 : 1000) * 1e6;
  }

  function dividirEmPartes(jobs, limite) {
    var partes = [];
    var atual = [];
    var soma = 0;
    jobs.forEach(function (j) {
      var t = tamanhoDe(j);
      if (atual.length && soma + t > limite) {
        partes.push(atual);
        atual = [];
        soma = 0;
      }
      atual.push(j);
      soma += t;
    });
    if (atual.length) partes.push(atual);
    return partes;
  }

  /* Mesma peça pode vir em várias linhas (tamanhos diferentes). */
  function pecasUnicas(pedido) {
    var vistos = {};
    var lista = [];
    (pedido.pecas || []).forEach(function (pc) {
      var chave = pc.handle || 'sem-link:' + pc.titulo;
      if (vistos[chave]) {
        vistos[chave].qtd += pc.qtd || 0;
        return;
      }
      var copia = { handle: pc.handle, titulo: pc.titulo, sku: pc.sku, qtd: pc.qtd || 0, img: pc.img };
      vistos[chave] = copia;
      lista.push(copia);
    });
    return lista;
  }

  function numeroLimpo(valor) {
    return String(valor == null ? '' : valor).replace(/[^0-9A-Za-z-]/g, '');
  }

  function acharPedido(valor) {
    var alvo = numeroLimpo(valor);
    if (!alvo) return null;
    for (var i = 0; i < pedidos.length; i++) {
      var p = pedidos[i];
      if (numeroLimpo(p.numero) === alvo || numeroLimpo(p.nome) === alvo) return p;
    }
    return null;
  }

  function pedidoCardHtml(pedido) {
    var pecas = pecasUnicas(pedido);
    var fotos = pecas.filter(function (p) { return p.img; }).slice(0, 3);
    var resto = pecas.length - fotos.length;
    return (
      '<li><button type="button" class="cm-pedido-card" data-cm-abrir-pedido="' + esc(pedido.numero) + '"' +
        ' aria-label="' + esc('Abrir o pedido ' + pedido.nome + ' de ' + pedido.data + ', ' + plural(pecas.length, 'peça', 'peças')) + '">' +
        '<span class="cm-pedido-card__topo">' +
          '<span class="cm-pedido-card__nome">' + esc(pedido.nome) + '</span>' +
          '<span class="cm-pedido-card__data">' + esc(pedido.data) + '</span>' +
        '</span>' +
        '<span class="cm-pedido-card__fotos" aria-hidden="true">' +
          fotos.map(function (p) { return '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="48" height="48">'; }).join('') +
          (resto > 0 ? '<span class="cm-pedido-card__mais">+' + resto + '</span>' : '') +
        '</span>' +
        '<span class="cm-pedido-card__pecas">' + plural(pecas.length, 'peça', 'peças') + '</span>' +
        '<span class="cm-pedido-card__acao">Baixar fotos e vídeos</span>' +
      '</button></li>'
    );
  }

  function renderPedidos() {
    var visiveis = pedidos.filter(function (p) { return !p.oculto; });
    if (!visiveis.length && !avisoPedidos) {
      els.pedidos.innerHTML = '';
      els.pedidos.hidden = true;
      return;
    }
    var limite = mostrarTodosPedidos ? visiveis.length : (parseInt(root.getAttribute('data-pedidos-qtd'), 10) || 8);
    var html =
      '<div class="cm-pedidos__head">' +
        '<h2 class="cm-pedidos__titulo">' + esc(TXT.pedidosTitulo) + '</h2>' +
        (TXT.pedidosSub ? '<p class="cm-pedidos__sub">' + esc(TXT.pedidosSub) + '</p>' : '') +
      '</div>';
    if (avisoPedidos) html += '<p class="cm-pedidos__aviso" role="status">' + esc(avisoPedidos) + '</p>';
    if (visiveis.length) {
      html += '<ul class="cm-pedidos__lista">' + visiveis.slice(0, limite).map(pedidoCardHtml).join('') + '</ul>';
      if (visiveis.length > limite) {
        html += '<div class="cm-pedidos__mais-wrap"><button type="button" class="aimer-dl aimer-dl--contorno cm-pedidos__mais" data-cm-pedidos-mais>' +
          'Ver pedidos mais antigos (' + (visiveis.length - limite) + ')</button></div>';
      }
    }
    els.pedidos.innerHTML = html;
    els.pedidos.hidden = false;
  }

  function mostrarListaPedidos(mostrar) {
    els.pedidos.hidden = !mostrar || !els.pedidos.innerHTML;
  }

  function atualizarUrl(numero) {
    if (!window.history || !window.history.replaceState || !window.URL) return;
    try {
      var u = new URL(window.location.href);
      if (numero) u.searchParams.set('pedido', numero);
      else u.searchParams.delete('pedido');
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (e) { /* URL antiga sem suporte: sem problema, só não atualiza a barra */ }
  }

  function fecharPedido() {
    if (!pedidoAberto) return;
    cancelarTarefa();
    pedidoAberto = null;
    pedidoToken += 1;
    els.pedidoPainel.hidden = true;
    els.pedidoPainel.innerHTML = '';
    els.voltar.textContent = TXT.voltar;
    atualizarUrl(null);
  }

  function carregarProdutos(handles) {
    var porHandle = {};
    var base = rotaRaiz();
    return runPool(handles, function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (p) { porHandle[h] = p; })
        .catch(function () { porHandle[h] = null; });
    }, 6).then(function () { return porHandle; });
  }

  function abrirPedido(pedido, opcoes) {
    opcoes = opcoes || {};
    cancelarTarefa();
    var token = ++pedidoToken;
    // partes: plano de divisão congelado quando o tamanho é medido — os botões
    // e o download usam o mesmo plano, mesmo que um HEAD atrasado chegue depois.
    pedidoAberto = { pedido: pedido, fotos: [], videos: [], indisponiveis: [], pecas: 0, partes: null };
    currentHandle = null;
    searchToken += 1; // descarta resposta de busca ainda a caminho
    els.busca.value = '';
    els.pedidos.hidden = true;
    els.colecoes.hidden = true;
    renderCatalogo(null);
    els.carregarMais.hidden = true;
    els.vazio.hidden = true;
    els.voltar.textContent = TXT.voltarPedido;
    els.voltar.hidden = false;
    els.gridTitulo.textContent = 'Pedido ' + pedido.nome + ' · ' + pedido.data;
    els.gridTitulo.hidden = false;
    els.grid.innerHTML = '';
    els.grid.hidden = false;
    els.pedidoPainel.innerHTML = '<p class="cm-pedido__resumo">Carregando as peças do pedido…</p>';
    els.pedidoPainel.hidden = false;
    atualizarUrl(pedido.numero);
    if (opcoes.rolar && els.voltar.scrollIntoView) {
      els.voltar.scrollIntoView({ behavior: opcoes.rolar, block: 'start' });
    }

    var pecas = pecasUnicas(pedido);
    var handles = pecas.filter(function (p) { return p.handle; }).map(function (p) { return p.handle; });
    carregarProdutos(handles).then(function (porHandle) {
      if (token !== pedidoToken) return;
      montarPedido(pecas, porHandle, token);
    });
  }

  function montarPedido(pecas, porHandle, token) {
    var estado = pedidoAberto;
    var cards = [];
    var n = 0;

    pecas.forEach(function (pc) {
      var p = pc.handle ? porHandle[pc.handle] : null;
      if (!p) {
        estado.indisponiveis.push(pc);
        return;
      }
      n += 1;
      var titulo = p.title || pc.titulo || 'Peça';
      var sku = pc.sku || (p.variants && p.variants[0] && p.variants[0].sku) || '';
      var base = limparNome(titulo);
      var pasta = doisDigitos(n) + ' ' + base + (sku ? ' - ' + limparNome(sku) : '');
      var nf = 0;
      var nv = 0;
      var midias = p.media && p.media.length ? p.media : (p.images || []).map(function (src) { return { media_type: 'image', src: src }; });

      midias.forEach(function (m) {
        if (m.media_type === 'image' && m.src) {
          nf += 1;
          var src = absUrl(m.src).split('?')[0];
          estado.fotos.push({
            tipo: 'foto',
            url: src + '?width=' + FULL_W,
            nome: pasta + '/' + base + ' - foto ' + doisDigitos(nf) + extensao(src, '.jpg'),
          });
        } else if (m.media_type === 'video') {
          var melhor = melhorMp4(m.sources);
          if (!melhor) return;
          nv += 1;
          estado.videos.push({
            tipo: 'video',
            url: absUrl(melhor.url),
            nome: pasta + '/' + base + ' - video ' + doisDigitos(nv) + '.mp4',
          });
        }
      });
      cards.push(normalizeAjaxProduct(p));
    });

    estado.pecas = n;
    indexProducts(cards);
    renderProducts(cards, false);
    renderPainelPedido();

    // Vídeos primeiro: são poucos e são eles que decidem em quantas partes o
    // .zip se divide. As fotos (centenas, ~0,4 MB cada, quase nunca passam do
    // limite) são medidas depois, só para o total exibido ficar exato.
    medirTamanhos(estado.videos, token, 10000).then(function () {
      if (token !== pedidoToken) return;
      var limite = limiteParte();
      estado.partes = {
        fotos: dividirEmPartes(estado.fotos, limite),
        videos: dividirEmPartes(estado.videos, limite),
      };
      renderPainelPedido();
      return medirTamanhos(estado.fotos, token, 30000).then(function () {
        if (token === pedidoToken) atualizarMeta('fotos', estado.fotos, estado.partes.fotos);
      });
    });
  }

  /* HEAD em cada arquivo para mostrar o tamanho real e dividir as partes.
     O CDN da Shopify responde com CORS liberado e Content-Length.
     Se a rede travar, segue com a estimativa depois do tempo-limite. */
  function medirTamanhos(jobs, token, limiteMs) {
    var corrida = runPool(jobs, function (job) {
      if (token !== pedidoToken || job.tamanho) return Promise.resolve();
      return fetch(job.url, { method: 'HEAD', mode: 'cors' })
        .then(function (r) {
          var n = parseInt(r.headers.get('content-length'), 10);
          if (r.ok && n > 0) job.tamanho = n;
        })
        .catch(function () {});
    }, 10);
    return Promise.race([corrida, esperar(limiteMs)]);
  }

  function metaTexto(tipo, jobs, partes) {
    var ehFoto = tipo === 'fotos';
    var exato = jobs.every(function (j) { return j.tamanho; });
    var texto = plural(jobs.length, ehFoto ? 'foto' : 'vídeo', ehFoto ? 'fotos' : 'vídeos') + ' · ' +
      (exato ? '' : '~') + fmtTamanho(somaTamanhos(jobs));
    if (partes && partes.length > 1) texto += ' · em ' + partes.length + ' arquivos .zip';
    return texto;
  }

  function atualizarMeta(tipo, jobs, partes) {
    var el = els.pedidoPainel.querySelector('[data-cm-meta="' + tipo + '"]');
    if (el) el.textContent = metaTexto(tipo, jobs, partes);
  }

  function blocoHtml(tipo, jobs, partes) {
    var ehFoto = tipo === 'fotos';
    var titulo = ehFoto ? 'Fotos' : 'Vídeos';
    if (!jobs.length) {
      return '<div class="cm-pedido__bloco"><p class="cm-pedido__bloco-titulo">' + titulo + '</p>' +
        '<p class="cm-pedido__bloco-meta">' + (ehFoto ? 'Nenhuma foto disponível.' : 'Nenhum vídeo nas peças deste pedido.') + '</p></div>';
    }
    var meta = metaTexto(tipo, jobs, partes);
    var botoes;
    if (!partes) {
      botoes = '<button type="button" class="aimer-dl" disabled>' + ICONE_BAIXAR +
        '<span class="aimer-dl__label">Calculando o tamanho…</span></button>';
    } else {
      botoes = partes.map(function (parte, i) {
        var rotulo = partes.length > 1
          ? 'Baixar ' + (ehFoto ? 'fotos' : 'vídeos') + ' — parte ' + (i + 1) + ' de ' + partes.length + ' (' + fmtTamanho(somaTamanhos(parte)) + ')'
          : 'Baixar ' + (ehFoto ? 'fotos' : 'vídeos') + ' (.zip)';
        return '<button type="button" class="aimer-dl" data-cm-baixar-pedido="' + tipo + '" data-parte="' + i + '">' +
          ICONE_BAIXAR + '<span class="aimer-dl__label">' + esc(rotulo) + '</span></button>';
      }).join('');
    }
    return '<div class="cm-pedido__bloco"><p class="cm-pedido__bloco-titulo">' + titulo + '</p>' +
      '<p class="cm-pedido__bloco-meta" data-cm-meta="' + tipo + '">' + esc(meta) + '</p><div class="cm-pedido__botoes">' + botoes + '</div></div>';
  }

  function renderPainelPedido() {
    var estado = pedidoAberto;
    if (!estado) return;
    var partes = estado.partes || {};
    var html = '<p class="cm-pedido__resumo">' +
      plural(estado.pecas, 'peça', 'peças') + ' · ' +
      plural(estado.fotos.length, 'foto', 'fotos') + ' · ' +
      plural(estado.videos.length, 'vídeo', 'vídeos') + '</p>';
    html += '<div class="cm-pedido__blocos">' +
      blocoHtml('fotos', estado.fotos, partes.fotos) +
      blocoHtml('videos', estado.videos, partes.videos) +
      '</div>';
    html += '<div class="cm-pedido__progresso" data-cm-progresso hidden>' +
      '<div class="cm-pedido__trilho"><span data-cm-progresso-barra></span></div>' +
      '<p class="cm-pedido__status" data-cm-progresso-texto role="status"></p></div>';
    if (estado.indisponiveis.length) {
      html += '<p class="cm-pedido__faltando">Sem fotos no site: ' +
        esc(estado.indisponiveis.map(function (p) { return p.titulo; }).join(', ')) + '.</p>';
    }
    html += '<p class="cm-pedido__dica">As fotos e os vídeos vêm numa pasta por peça, com o nome e o SKU. ' +
      (telaDeToque()
        ? 'No celular, o .zip vai para Arquivos (iPhone) ou Downloads (Android): toque nele para abrir as pastas. Os vídeos são pesados — prefira o Wi-Fi.'
        : 'Para baixar só algumas fotos, use os botões de cada peça logo abaixo.') +
      '</p>';
    els.pedidoPainel.innerHTML = html;
  }

  function mostrarProgresso(fracao, texto) {
    var box = els.pedidoPainel.querySelector('[data-cm-progresso]');
    if (!box) return;
    box.hidden = false;
    box.querySelector('[data-cm-progresso-barra]').style.width = Math.round(Math.max(0, Math.min(1, fracao)) * 100) + '%';
    box.querySelector('[data-cm-progresso-texto]').textContent = texto;
  }

  function travarBotoes(travar, exceto) {
    els.pedidoPainel.querySelectorAll('[data-cm-baixar-pedido]').forEach(function (b) {
      if (b !== exceto) b.disabled = travar;
    });
  }

  /* Cancela o download de pedido em andamento (troca de pedido, voltar,
     busca). A tarefa é solta na hora; o fim da promessa antiga só mexe na
     tela se ela ainda for a tarefa atual. */
  function cancelarTarefa() {
    if (!tarefa) return;
    if (tarefa.controle) tarefa.controle.abort();
    tarefa = null;
  }

  function baixarParteDoPedido(botao) {
    var estado = pedidoAberto;
    var tipo = botao.getAttribute('data-cm-baixar-pedido');
    var indice = parseInt(botao.getAttribute('data-parte'), 10) || 0;
    var partes = estado.partes && estado.partes[tipo];
    var jobs = (partes && partes[indice]) || [];
    if (!jobs.length) return;

    var ehFoto = tipo === 'fotos';
    var nomeZip = 'Aimer - pedido ' + numeroLimpo(estado.pedido.numero) + ' - ' + tipo +
      (partes.length > 1 ? ' - parte ' + (indice + 1) + ' de ' + partes.length : '') + '.zip';
    var controle = window.AbortController ? new AbortController() : null;
    var label = botao.querySelector('.aimer-dl__label');
    var rotulo = label.textContent;
    var minha = { botao: botao, controle: controle };

    tarefa = minha;
    revogarEntregues();
    if (controle) {
      label.textContent = 'Cancelar';
      botao.classList.add('is-cancelar');
    } else {
      botao.disabled = true;
    }
    travarBotoes(true, botao);
    mostrarProgresso(0, 'Preparando…');

    baixarArquivos(jobs, {
      sinal: controle ? controle.signal : null,
      aoProgredir: function (feitos, bytes) {
        if (tarefa !== minha) return;
        var total = somaTamanhos(jobs);
        mostrarProgresso(total ? bytes / total : feitos / jobs.length,
          'Baixando ' + feitos + ' de ' + plural(jobs.length, ehFoto ? 'foto' : 'vídeo', ehFoto ? 'fotos' : 'vídeos') +
          ' · ' + fmtTamanho(bytes) + ' de ' + fmtTamanho(total));
      },
    }).then(function (res) {
      if (tarefa !== minha) return;
      if (!res.arquivos.length) throw new Error('nenhum arquivo baixou');
      mostrarProgresso(1, 'Montando o arquivo .zip…');
      return esperar(30).then(function () {
        if (tarefa !== minha) return;
        salvarBlob(montarZip(res.arquivos), nomeZip);
        botao.classList.add('is-feito');
        mostrarProgresso(1, res.falhas.length
          ? 'Pronto! ' + res.arquivos.length + ' de ' + jobs.length + ' arquivos no .zip — ' + plural(res.falhas.length, 'arquivo não baixou', 'arquivos não baixaram') + '; tente de novo mais tarde.'
          : 'Pronto! “' + nomeZip + '” foi para os seus downloads.');
      });
    }).catch(function (err) {
      if (controle && controle.signal.aborted) {
        if (estado === pedidoAberto) mostrarProgresso(0, 'Download cancelado.');
        return;
      }
      if (tarefa !== minha) return;
      mostrarProgresso(0, 'Não foi possível montar o .zip. Confira a internet e tente de novo.');
      if (window.console) console.error('[aimer-central-midia] zip do pedido falhou:', err);
    }).then(function () {
      if (tarefa === minha) tarefa = null;
      label.textContent = rotulo;
      botao.classList.remove('is-cancelar');
      botao.disabled = false;
      if (estado === pedidoAberto && !tarefa) travarBotoes(false);
    });
  }

  els.pedidos.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-cm-abrir-pedido]');
    if (abrir) {
      var pedido = acharPedido(abrir.getAttribute('data-cm-abrir-pedido'));
      if (pedido) abrirPedido(pedido, { rolar: 'smooth' });
      return;
    }
    if (e.target.closest('[data-cm-pedidos-mais]')) {
      mostrarTodosPedidos = true;
      renderPedidos();
    }
  });

  els.pedidoPainel.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-cm-baixar-pedido]');
    if (!botao || !pedidoAberto || botao.disabled) return;
    if (tarefa) {
      if (tarefa.botao === botao) cancelarTarefa();
      return;
    }
    baixarParteDoPedido(botao);
  });

  /* Início: lista de pedidos + link direto ?pedido= (e-mail de confirmação). */
  var pedidoNaUrl = null;
  try { pedidoNaUrl = new URLSearchParams(window.location.search).get('pedido'); } catch (e) { pedidoNaUrl = null; }
  var pedidoDoLink = pedidoNaUrl ? acharPedido(pedidoNaUrl) : null;
  if (pedidoNaUrl && !pedidoDoLink) {
    avisoPedidos = pedidos.length
      ? 'Não encontramos o pedido #' + numeroLimpo(pedidoNaUrl) + ' nesta conta. Confira se você entrou com o mesmo e-mail usado na compra.'
      : 'Para baixar as fotos do pedido #' + numeroLimpo(pedidoNaUrl) + ', entre com o mesmo e-mail usado na compra.';
  }
  renderPedidos();
  if (pedidoDoLink) abrirPedido(pedidoDoLink, { rolar: 'auto' }); // página recém-aberta: vai direto, sem animação
})();
